import { ReactNode } from "react";
import { useAuthStore } from "@/store/authStore";
import type { Permission } from "@/utils/permissions";

interface RequirePermissionProps {
  required: Permission | Permission[];
  children: ReactNode;
  fallback?: ReactNode;
}

export function RequirePermission({ required, children, fallback }: RequirePermissionProps) {
  const permissions = useAuthStore((s) => s.user?.permissions ?? []);
  const requiredList = Array.isArray(required) ? required : [required];
  const hasAll = requiredList.every((p) => permissions.includes(p));

  if (!hasAll) {
    return (
      <>
        {fallback || (
          <div className="flex flex-col items-center justify-center p-12">
            <h2 className="text-lg font-semibold text-gray-900">Permission Denied</h2>
            <p className="mt-1 text-sm text-gray-500">
              You do not have the required permissions to access this page.
            </p>
          </div>
        )}
      </>
    );
  }

  return <>{children}</>;
}
